import dxForm from "devextreme/ui/form";
import { Level } from "../Location.Mappings";
import { getItemOptions, setEditorOptions, setItemOptions } from "#/common/components/Form/formItemOption";
import { inUseStatuses } from "../../utils/constants";

export const onLevelChange = (
  form: dxForm,
  value: Level | null,
  init: boolean,
): void => {
  if (!init) {
    form.updateData('parentId', null);
  }

  const parentRequired = !!value && value !== Level.Country;
  const parentPlaceholder = (() => {
    if (!value) return 'Select a Type first';
    if (value === Level.Country) return 'Not Applicable';
    return 'Search and select...';
  })();

  const parentLevel = (() => {
    switch(value) {
      case Level.Building: return Level.City;
      case Level.City: return Level.State;
      case Level.State: return Level.Country;
      default: return null;
    }
  })();

  setItemOptions(form, 'parentId', 'isRequired', parentRequired);

  const parentDsOptions = getItemOptions(form, 'parentId')?.editorOptions?.dataStoreOptions ?? {};
  setEditorOptions(form, 'parentId', {
    disabled: !parentRequired,
    placeholder: parentPlaceholder,
    dataStoreOptions: {
      ...parentDsOptions,
      filter: [
        ['inUseStatus', '=', inUseStatuses.inUse.key],
        'and',
        ['level', '=', parentLevel]
      ],
    }
  });
};